import axios from 'axios';

import { GetToken } from './Session'
import { Filter } from './Filter'

export function GetTicketById(id) {
	return axios.get('/api/v1/tickets/'+id, {headers: { Authorization: 'Bearer ' + GetToken().access_token }})
}

export function GetTicket(q) {
	return axios.get('/api/v1/tickets'+Filter(q), {headers: { Authorization: 'Bearer ' + GetToken().access_token }})
}

export function GetTicketByOrderID(id) {
	return axios.get('/api/v1/orders/'+id+'/tickets?per_page=100', {headers: { Authorization: 'Bearer ' + GetToken().access_token }})
}
